import { CCErrorReturnType, CCFieldDescriptorType } from "./types/descriptors";

export function defaultStringLikeErrorCheck(
  target: JQuery,
  value: string
): CCErrorReturnType<string> {
  const err = Boolean(
    target.hasClass("cc-optional") ? false : !value.trim().length
  );
  return { isError: err, value: err ? null : value };
}

export function defaultStringLikeGet(target: JQuery | undefined): string {
  if (target?.hasClass("richTextEnabled")) {
    return String(tinymce.activeEditor.getContent({ format: "html" }));
  } else {
    return String(target?.val() || "");
  }
}

export function defaultNumberLikeErrorCheck(
  target: JQuery,
  value: number
): CCErrorReturnType<number> {
  const err = Boolean(target.hasClass("cc-optional") ? false : isNaN(value));
  return { isError: err, value: err ? null : value };
}

export const CCFieldDescriptors: CCFieldDescriptorType = {
  /**
   * These objects describe how to read the value
   * of a field and how to check the field for an error.
   */
  Check: {
    getValue: (target: JQuery | undefined): boolean => {
      return Boolean(target?.is(":checked") || false);
    },
    errorCheck: (
      _target: JQuery,
      value: boolean
    ): CCErrorReturnType<boolean> => {
      const isReq = Boolean(_target.attr("data-check-required"));
      return { isError: isReq && !value, value: value };
    },
    eventType: "change"
  },
  Radio: {
    getValue: (target: JQuery | undefined): string => {
      const allBtns = target.closest(".cc-radio-wrapper").children();
      return allBtns.filter(":checked").first().attr("data-radio-value") ?? "";
    },
    errorCheck: (target: JQuery, value: string): CCErrorReturnType<string> => {
      const allBtns = target.closest(".cc-radio-wrapper").children();
      const checked = allBtns.filter(":checked");
      return {
        isError: checked.length == 0,
        value: checked.length == 0 ? null : value
      };
    },
    eventType: "change"
  },
  String: {
    getValue: defaultStringLikeGet,
    errorCheck: defaultStringLikeErrorCheck,
    eventType: "input"
  },
  Date: {
    getValue: defaultStringLikeGet,
    errorCheck: defaultStringLikeErrorCheck,
    eventType: "input"
  },
  Paragraph: {
    getValue: defaultStringLikeGet,
    errorCheck: (target: JQuery, value: string): CCErrorReturnType<string> => {
      const key = target.data("key");
      const wordLimit = target.data("paragraph-word-limit");
      let { isError: err } = defaultStringLikeErrorCheck(target, value);
      if (wordLimit != undefined) {
        const words = value.split(/(?: |\n)+/).filter((text) => {
          return text.trim().length > 0;
        });
        if (words.length > Number(wordLimit)) err = true;
        const paragraphTitle = $(
          `.confParagraphTitle[data-label-for="${key}"]`
        );
        const currentTitle = paragraphTitle.text();
        const titleEndIndex = currentTitle.lastIndexOf(":");
        paragraphTitle.text(
          `${currentTitle.substring(0, titleEndIndex)}: ${words.length}/${wordLimit} words`
        );
        paragraphTitle.css(
          "color",
          words.length > Number(wordLimit) ? "#ad310e" : ""
        );
      }

      return { isError: err, value };
    },
    eventType: "input"
  },
  Select: {
    getValue: defaultStringLikeGet,
    errorCheck: (target: JQuery, value: string): CCErrorReturnType<string> => {
      const err = target.hasClass("cc-optional")
        ? false
        : value.toLowerCase() == "choose";
      return { isError: err, value: err ? null : value };
    },
    eventType: "change"
  },
  Float: {
    getValue: (target: JQuery | undefined): number => {
      return parseFloat(target?.val().toString());
    },
    errorCheck: defaultNumberLikeErrorCheck,

    eventType: "input"
  },
  Integer: {
    getValue: (target: JQuery | undefined): number => {
      return parseInt(target?.val().toString());
    },
    errorCheck: defaultNumberLikeErrorCheck,
    eventType: "input"
  }
};
